// tslint:disable jsx-no-lambda
import * as classNames from "classnames";
import * as React from "react";

import { HTMLDivProps} from "@blueprintjs/core";

import { GroupsListItem } from 'src/components';

import "./styles.css";

export interface IGroupListProps extends HTMLDivProps {
  list: Array<any>;
  onAudienceBoxCheckBoxChange(event: any, index: number): void;
}

export const GroupList: React.SFC<IGroupListProps> = props => {
  const { className, onAudienceBoxCheckBoxChange, list } = props;
  const classes = classNames("groups-list", className);

  return (
    <div className={classes}>
      <div className="groups-inner-list">
        {list.map((element, index) => (
            <GroupsListItem
              onChange={e => onAudienceBoxCheckBoxChange(e, index)}
              checked={element.checked}
              title={element.title}
              description={element.description}
              members={element.members}
              type={element.type}
              key={index}
            /> 
          ))}
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/controllers/alerts/compose/choose-audience/group-list.tsx